import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { saveWeddingWebsiteText } from "../../../redux/rsvpSlice.js";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const quillModules = {
  toolbar: [
    ['link']
  ],
};

const quillFormats = ["link"];

const isBlank = (s) => {
  return s==="" || s==="<p><br></p>" || s=="<p></p>" || s===null || s===undefined;
}

const OurStory = ({ details }) => {
  const dispatch = useDispatch();
  const [metStory, setMetStory] = useState(details?.couple?.met_text);
  const [proposalStory, setProposalStory] = useState(details?.couple?.proposal_text);
  const [isMetStoryEditable, setIsMetStoryEditable] = useState(false);
  const [isProposalStoryEditable, setIsProposalStoryEditable] = useState(false);

  const metStoryRef = useRef(null);
  const proposalStoryRef = useRef(null);

  useEffect(() => {
    const nav1 = document.getElementById("ww-menu-qanda");
    if (nav1) nav1.style.display=(isBlank(metStory) ? "none" : "");
    const nav2 = document.getElementById("ww-menu-proposal");
    if (nav2) nav2.style.display=(isBlank(proposalStory) ? "none" : "");
  }, [metStory, proposalStory]);

  const handleMetStory = (value) => {
    setMetStory(value);
  };
  const handleProposalStory = (value) => {
    setProposalStory(value);
  };

  const handleEditMetStory = () => {
    setIsMetStoryEditable(true);
  };

  const handleEditProposalStory = () => {
    setIsProposalStoryEditable(true);
  };

  useEffect(()=>{
    if (isMetStoryEditable && metStoryRef) {
      metStoryRef.current.focus();
    }
  }, [metStoryRef, isMetStoryEditable])

  useEffect(()=>{
    if (isProposalStoryEditable && proposalStoryRef) {
      proposalStoryRef.current.focus();
    }
  }, [proposalStoryRef, isProposalStoryEditable])


  const handleSaveMetStory = () => {
    setIsMetStoryEditable(false);
    dispatch(saveWeddingWebsiteText({field: "met_text", value: metStoryRef.current.value}));
  };

  const handleSaveProposalStory = () => {
    setIsProposalStoryEditable(false);
    dispatch(saveWeddingWebsiteText({field: "proposal_text", value: proposalStoryRef.current.value}));
  };

  return (
    <div id="our-story">
      <section className="web-inner-page our-story">
        <div className="container">
          <div className="row">
          </div>
          <div className="row">
            {!isBlank(metStory) && <div className="col-lg-6 col-md-6">
              <div className="meet-bt-box">
                <div className="meet-bt">
                  <div className="title-bt"> Q &amp; A </div>
                  {/*<div className="date-bt"> 2022 </div>*/}
                  {details.owner && (
                    isMetStoryEditable ? 
                    <button className="date-bt" onClick={handleSaveMetStory}>Save</button>
                    : (
                      <button className="date-bt" onClick={handleEditMetStory}>
                        &#9997;
                      </button>
                  ) )}
                </div>
                <div className="clearfix"></div>

                {details.owner && isMetStoryEditable ? 
                
                <ReactQuill 
                modules={quillModules} 
                formats={quillFormats} 
                className="title-text"
                placeholder="Share further details of your event"
                value={metStory}
                ref={metStoryRef}
                onChange={handleMetStory}
              /> : 
                <div className="title-text" style={{whiteSpace:"pre-line",height:"auto"}} dangerouslySetInnerHTML={{__html:metStory}}>
                </div>}

                <div className="clearfix"></div>
              </div>
            </div>}
            {!isBlank(proposalStory) && <div className="col-lg-6 col-md-6">
              <div className="meet-bt-box">
                <div className="meet-bt">
                  <div className="title-bt"> Proposal </div>
                  {/*<div className="date-bt"> 2022 </div>*/}
                  {details.owner && (
                    isProposalStoryEditable ? 
                    <button className="date-bt" onClick={handleSaveProposalStory}>Save</button>
                    : (
                      <button
                        className="date-bt"
                        onClick={handleEditProposalStory}
                      >
                        &#9997;
                      </button>
                  ))}
                </div>
                <div className="clearfix"></div>

                {details.owner && isProposalStoryEditable ? 
                  <ReactQuill 
                    modules={quillModules} 
                    formats={quillFormats} 
                    className="title-text"
                    placeholder="Share your proposal story!"
                    value={proposalStory}
                    ref={proposalStoryRef}
                    onChange={handleProposalStory}
                  />
                : 
                <div className="title-text" style={{whiteSpace:"pre-line",height:"auto"}} dangerouslySetInnerHTML={{__html:proposalStory}}>
                </div> }

                <div className="clearfix"></div>
              </div>
            </div>}
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurStory;
